import { render, staticRenderFns } from "./RecapitulatifPaiement.vue?vue&type=template&id=5fa7a6be"
import script from "./RecapitulatifPaiement.vue?vue&type=script&lang=js"
export * from "./RecapitulatifPaiement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports